export default "__VITE_ASSET__b4cf8148__"